module.exports = __webpack_public_path__ + "static/media/groot.a0728df2.png";